export default __webpack_public_path__ + "static/media/bg_seeking_create.8b8097a8.jpg";